import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {LoggerService} from "../../../../core/logger.service";
import {BusinessHoursDto, PointOfSaleDto} from "../../point-of-sale-dto";

@Component({
    selector: 'general-setting',
    templateUrl: './general-setting.component.html',
    providers: []
})
export class GeneralSettingComponent implements OnInit{

    @Input() dto:PointOfSaleDto;
    @Input() isEditing:boolean = false;
    @Input() errors;
    @Input() errorMessages;
    @Input() data;

    constructor(private logger: LoggerService) {
        logger.info('GeneralSettingComponent: logger.info()');
    }

    ngOnInit(): void {
    }


}



// WEBPACK FOOTER //
// ./public/upgrade/feature/pointOfSale/edit/general-setting/general-setting.component.ts